import * as React from 'react';
import * as PropTypes from 'prop-types';
import { SuperAgentLevelView } from '../../components/SuperAgentLevelView';
import { getTooltipText } from './utils';
import { IConfig } from '@cian/config/shared';

type TSuperAgentLevelViewContainerProps = {
  levelNumber: number;
  levelName: string;
};

const SUPER_AGENT_LEVEL = 4;

export const SuperAgentLevelViewContainer = (
  { levelNumber, levelName }: TSuperAgentLevelViewContainerProps,
  { config }: { config: IConfig },
) => {
  if (levelNumber !== SUPER_AGENT_LEVEL) {
    return null;
  }

  const tooltipText = getTooltipText(config);

  return <SuperAgentLevelView tooltipText={tooltipText} levelName={levelName} />;
};

SuperAgentLevelViewContainer.contextTypes = {
  config: PropTypes.object,
};
